/* Chummys collection pages: reveal, the counter (rail + tap-to-pack), chip → card jump, sort */
(function () {
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal on scroll (guarded by html.js in CSS, so no-JS always shows)
  var items = document.querySelectorAll('.chummys-cg [data-reveal], .chummys-guide [data-reveal]');
  if ('IntersectionObserver' in window && !rm) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  // ---- the shelf: the counter's rail, but every item is a link to its own box (cupcakes) ----
  Array.prototype.forEach.call(document.querySelectorAll('[data-shelf]'), function (shelf) { (function () {
    var rail = shelf.querySelector('[data-rail]'), track = shelf.querySelector('[data-track]');
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-shelf-item]'));
    if (!rail || !track || !items.length) return;
    items.forEach(function (it) { var c = it.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); track.appendChild(c); });
    var x = 0, W = 0, vel = 0, paused = false, dragging = false, moved = false, lastX = 0, lastT = 0, startX = 0, pid = null, tapUntil = 0;
    var speed = rm ? 0 : 20;
    var measure = function () { W = track.scrollWidth / 2; };
    var wrap = function () { if (W > 0) { while (x <= -W) x += W; while (x > 0) x -= W; } };
    var apply = function () { track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; };
    var last = performance.now();
    var frame = function (now) { var dt = Math.min(48, now - last) / 1000; last = now; if (!dragging) { if (Math.abs(vel) > 6) { x += vel * dt; vel *= 0.93; } else { vel = 0; if (!paused && document.visibilityState === 'visible') x -= speed * dt; } } wrap(); apply(); requestAnimationFrame(frame); };
    measure(); apply(); requestAnimationFrame(frame);
    window.addEventListener('resize', measure); window.addEventListener('load', measure);
    rail.addEventListener('mouseenter', function () { paused = true; }); rail.addEventListener('mouseleave', function () { paused = false; });
    rail.addEventListener('focusin', function () { paused = true; }); rail.addEventListener('focusout', function () { paused = false; });
    rail.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button !== 0) return; dragging = true; moved = false; pid = e.pointerId; startX = lastX = e.clientX; lastT = e.timeStamp; vel = 0; });
    rail.addEventListener('pointermove', function (e) { if (!dragging || e.pointerId !== pid) return; var dx = e.clientX - lastX, dt = Math.max(1, e.timeStamp - lastT); if (!moved && Math.abs(e.clientX - startX) > 6) { moved = true; rail.classList.add('is-dragging'); try { rail.setPointerCapture(e.pointerId); } catch (err) {} } if (!moved) return; x += dx; vel = vel * 0.6 + (dx / dt * 1000) * 0.4; lastX = e.clientX; lastT = e.timeStamp; wrap(); apply(); });
    var end = function () { if (!dragging) return; dragging = false; rail.classList.remove('is-dragging'); if (moved) { tapUntil = Date.now() + 500; moved = false; } };
    rail.addEventListener('pointerup', end); rail.addEventListener('pointercancel', end);
    rail.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); x -= e.deltaX; wrap(); apply(); } }, { passive: false });
    rail.addEventListener('click', function (e) { if (moved || Date.now() < tapUntil) { e.preventDefault(); e.stopPropagation(); } }, true);
  })(); });

  // ---- the counter: a drifting, draggable rail of real squares; tap one to pack your box ----
  Array.prototype.forEach.call(document.querySelectorAll('[data-counter]'), function (counter) { (function () {
    var productUrl = counter.getAttribute('data-product-url') || '/';
    var rail = counter.querySelector('[data-rail]'), track = counter.querySelector('[data-track]');
    var squares = Array.prototype.slice.call(track.querySelectorAll('[data-square]'));
    var tray = counter.querySelector('[data-tray]'), slotsEl = counter.querySelector('[data-slots]');
    var countEl = counter.querySelector('[data-count]'), note = counter.querySelector('[data-note]');
    var cta = counter.querySelector('[data-cta]'), ctaText = counter.querySelector('[data-cta-text]');
    var copy = {}; try { copy = JSON.parse(counter.querySelector('[data-counter-copy]').textContent); } catch (e) {}
    var sizeBtns = Array.prototype.slice.call(counter.querySelectorAll('[data-size]'));
    var active = sizeBtns.filter(function (b) { return b.classList.contains('is-on'); })[0] || sizeBtns[0];
    var limit = active ? (parseInt(active.getAttribute('data-n'), 10) || 6) : 6;
    var variant = active ? active.getAttribute('data-variant') : counter.getAttribute('data-variant');
    var picks = [];
    try {
      var saved = JSON.parse(sessionStorage.getItem('chummys:counter:' + productUrl) || 'null');
      if (saved && saved.picks) {
        picks = saved.picks.slice(0, 12);
        var sb = sizeBtns.filter(function (b) { return b.getAttribute('data-variant') === saved.variant; })[0];
        if (sb) { sizeBtns.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-pressed', 'false'); }); sb.classList.add('is-on'); sb.setAttribute('aria-pressed', 'true'); limit = parseInt(sb.getAttribute('data-n'), 10) || limit; variant = saved.variant; }
        if (picks.length > limit) picks = picks.slice(0, limit);
      }
    } catch (e) {}

    // the rail loops: a second copy of the set follows the first
    var clones = squares.map(function (sq) { var c = sq.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); c.setAttribute('data-clone', '1'); track.appendChild(c); return c; });
    var all = squares.concat(clones);
    var x = 0, W = 0, vel = 0, paused = false, dragging = false, moved = false, lastX = 0, lastT = 0, startX = 0;
    var speed = rm ? 0 : 20; // px per second
    var measure = function () { W = track.scrollWidth / 2; };
    var wrap = function () { if (W > 0) { while (x <= -W) x += W; while (x > 0) x -= W; } };
    var apply = function () { track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; };
    var last = performance.now();
    var frame = function (now) {
      var dt = Math.min(48, now - last) / 1000; last = now;
      if (!dragging) { if (Math.abs(vel) > 6) { x += vel * dt; vel *= 0.93; } else { vel = 0; if (!paused && document.visibilityState === 'visible') x -= speed * dt; } }
      wrap(); apply(); requestAnimationFrame(frame);
    };
    measure(); apply(); requestAnimationFrame(frame);
    window.addEventListener('resize', measure); window.addEventListener('load', measure);
    rail.addEventListener('mouseenter', function () { paused = true; }); rail.addEventListener('mouseleave', function () { paused = false; });
    rail.addEventListener('focusin', function () { paused = true; }); rail.addEventListener('focusout', function () { paused = false; });
    // A press is a tap until the pointer travels more than 6px; only then does the rail take the pointer
    // (capturing on press would make the browser fire the click on the rail, not the square).
    var tapUntil = 0, pid = null;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = false; pid = e.pointerId; startX = lastX = e.clientX; lastT = e.timeStamp; vel = 0;
    });
    rail.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      var dx = e.clientX - lastX, dt = Math.max(1, e.timeStamp - lastT);
      if (!moved && Math.abs(e.clientX - startX) > 6) { moved = true; rail.classList.add('is-dragging'); try { rail.setPointerCapture(e.pointerId); } catch (err) {} }
      if (!moved) return;
      x += dx; vel = vel * 0.6 + (dx / dt * 1000) * 0.4; lastX = e.clientX; lastT = e.timeStamp; wrap(); apply();
    });
    var end = function (e) {
      if (!dragging) return;
      dragging = false; rail.classList.remove('is-dragging');
      if (moved) { tapUntil = Date.now() + 500; moved = false; return; }
      vel = 0;
      // a clean tap: add straight from pointer-up, then swallow the click that follows so it cannot add twice
      if (e && e.type === 'pointerup') {
        var sq = (e.target && e.target.closest && e.target.closest('[data-square]')) || (document.elementFromPoint(e.clientX, e.clientY) || {}).closest && document.elementFromPoint(e.clientX, e.clientY).closest('[data-square]');
        if (sq) { tapUntil = Date.now() + 600; add(sq); }
      }
    };
    rail.addEventListener('pointerup', end); rail.addEventListener('pointercancel', end);
    rail.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); x -= e.deltaX; wrap(); apply(); } }, { passive: false });
    rail.addEventListener('click', function (e) { if (moved || Date.now() < tapUntil) { e.preventDefault(); e.stopPropagation(); } }, true);
    squares.forEach(function (sq) { sq.addEventListener('focus', function () { var kb = false; try { kb = sq.matches(':focus-visible'); } catch (e) {} if (!kb || dragging) return; x = -(sq.offsetLeft - 24); wrap(); apply(); }); });

    var render = function () {
      slotsEl.innerHTML = ''; slotsEl.classList.toggle('is-twelve', limit > 6);
      for (var i = 0; i < limit; i++) {
        var d = document.createElement('div'); d.className = 'chummys-tray__slot' + (picks[i] ? ' is-filled' : '');
        if (picks[i]) {
          var im = document.createElement('img'); im.src = picks[i].thumb; im.alt = picks[i].name; im.width = 64; im.height = 64; d.appendChild(im);
          var rmb = document.createElement('button'); rmb.type = 'button'; rmb.className = 'chummys-tray__remove'; rmb.setAttribute('aria-label', 'Remove ' + picks[i].name); rmb.setAttribute('data-remove', String(i)); rmb.textContent = '×'; d.appendChild(rmb);
        }
        slotsEl.appendChild(d);
      }
      var n = picks.length;
      countEl.textContent = n + ' of ' + limit;
      tray.classList.toggle('is-full', n >= limit);
      note.textContent = n === 0 ? (copy.empty || '') : (n >= limit ? (copy.full || '') : (copy.some || ''));
      cta.setAttribute('aria-disabled', n === 0 ? 'true' : 'false');
      ctaText.textContent = n >= limit ? (copy.ctaFull || copy.cta || 'Send this box') : (copy.cta || 'Send this box');
      var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(variant || '') + (n ? '&box=' + picks.map(function (p) { return p.handle; }).join(',') : '');
      cta.setAttribute('href', url);
      try { sessionStorage.setItem('chummys:counter:' + productUrl, JSON.stringify({ picks: picks, variant: variant })); } catch (e) {}
    };
    var fly = function (fromEl, toEl, src, done) {
      if (rm || !fromEl || !toEl || !fromEl.animate) { done(); return; }
      var a = fromEl.getBoundingClientRect(), b = toEl.getBoundingClientRect();
      var g = document.createElement('img'); g.src = src; g.alt = ''; g.className = 'chummys-fly';
      g.style.left = a.left + 'px'; g.style.top = a.top + 'px'; g.style.width = a.width + 'px'; g.style.height = a.height + 'px';
      document.body.appendChild(g);
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2), sc = (b.width * 0.86) / a.width;
      var finished = false, finish = function () { if (finished) return; finished = true; if (g.parentNode) g.remove(); done(); };
      var anim = g.animate([
        { transform: 'translate(0,0) rotate(0deg) scale(1)' },
        { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 70) + 'px) rotate(-14deg) scale(' + ((1 + sc) / 2) + ')', offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(0deg) scale(' + sc + ')' }
      ], { duration: 640, easing: 'cubic-bezier(.2,.8,.2,1)' });
      anim.onfinish = finish; setTimeout(finish, 900);
    };
    var add = function (sq) {
      if (picks.length >= limit) { tray.classList.remove('is-shake'); void tray.offsetWidth; tray.classList.add('is-shake'); note.textContent = copy.full || ''; return; }
      var img = sq.querySelector('img'); var src = img.currentSrc || img.src;
      picks.push({ name: sq.getAttribute('data-name'), handle: sq.getAttribute('data-handle'), thumb: src.replace(/\.png/, '-sm.png') });
      render();
      var slot = slotsEl.children[picks.length - 1]; if (slot) slot.classList.add('is-pending');
      fly(img, slot, src, function () { if (slot) { slot.classList.remove('is-pending'); slot.classList.add('is-landed'); } });
    };
    // keyboard (Enter/Space) still arrives as a click with no pointer sequence before it
    all.forEach(function (sq) { sq.addEventListener('click', function () { if (moved || Date.now() < tapUntil) return; add(sq); }); });
    slotsEl.addEventListener('click', function (e) { var b = e.target.closest('[data-remove]'); if (!b) return; picks.splice(parseInt(b.getAttribute('data-remove'), 10), 1); render(); });
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () {
      sizeBtns.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-pressed', 'false'); });
      b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
      limit = parseInt(b.getAttribute('data-n'), 10) || 6; variant = b.getAttribute('data-variant');
      if (picks.length > limit) picks = picks.slice(0, limit);
      render();
    }); });
    render();
  })(); });

  // chips and guide cards that point at a box on this page scroll to it instead of leaving
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-card]'));
  var byHref = function (href) {
    try {
      var u = new URL(href, location.href);
      if (u.pathname.indexOf('/products/') === -1) return null;
      var parts = u.pathname.split('/').filter(Boolean);
      var h = parts[parts.length - 1];
      for (var i = 0; i < cards.length; i++) if (cards[i].getAttribute('data-handle') === h) return cards[i];
    } catch (e) { /* ignore */ }
    return null;
  };
  document.querySelectorAll('[data-jump]').forEach(function (a) {
    var card = byHref(a.getAttribute('href'));
    if (!card) return;
    a.setAttribute('data-jump', 'card');
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var top = card.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top: top, behavior: rm ? 'auto' : 'smooth' });
      cards.forEach(function (c) { c.classList.remove('is-hit'); });
      card.classList.add('is-hit');
      setTimeout(function () { card.classList.remove('is-hit'); }, 2200);
    });
  });

  // sort
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });
})();

/* ---- the tabbed counter on hub pages: one panel showing at a time; rails re-measure when their panel appears ---- */
(function () {
  var wrap = document.querySelector('[data-counters]'); if (!wrap) return;
  var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-counter-tab]')), panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-counter-panel]'));
  var show = function (key) {
    tabs.forEach(function (t) { var on = t.getAttribute('data-counter-tab') === key; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-counter-panel') !== key; });
    window.dispatchEvent(new Event('resize'));
    try { history.replaceState(null, '', '#counter-' + key); } catch (e) {}
  };
  tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-counter-tab')); }); });
  wrap.addEventListener('keydown', function (e) { var i = tabs.indexOf(document.activeElement); if (i < 0) return; var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); show(n.getAttribute('data-counter-tab')); });
  var m = (location.hash || '').match(/^#counter-([\w-]+)$/); if (m && tabs.some(function (t) { return t.getAttribute('data-counter-tab') === m[1]; })) show(m[1]);
})();
